export default "__VITE_ASSET__CZrH3ERf__"